import { NumberedAccordion } from '~/ui-rocco/pages/detail-shared';
import { useProductAccordionRows } from './spec-accordion/use-product-accordion-rows';

/**
 * F7 — numbered spec accordion. The rows (and the "(NN)" numbering source) are
 * built by {@link useProductAccordionRows}; this just adds the design's 80px
 * spacer above each row's content and renders the accordion.
 */
export const ProductSpecAccordionSection = () => {
    const { rows, defaultOpenTitles } = useProductAccordionRows();

    // The design (1846:9004 et al) puts an 80px spacer between the trigger and
    // every row's content, and 80px below it (contents carry 1.8rem already).
    const spacedRows = rows.map((row) => ({
        ...row,
        content: (
            <div className="pt-[5rem] pb-[3.2rem] max-md:pt-6 max-md:pb-4">
                {row.content}
            </div>
        ),
    }));

    return (
        <NumberedAccordion
            headingLevel={2}
            rows={spacedRows}
            multiple
            defaultOpenTitles={defaultOpenTitles}
        />
    );
};
